import React, {useState} from 'react';
import {CardMenuLocal} from "./components/CardMenuLocal";
import {SeccionFactura} from "./components/SeccionFactura";
import {SeccionTurnos} from "../../components/SeccionTurnos/SeccionTurnos";


export const FacturaPage = () => {
    const [mostrarTrurnos, setMostrarTrurnos] = useState(false);
    return (
        <>
           {/* <div className="flex flex-wrap">
                <div className="w-ful relative mx-auto lg:w-4/12 px-4">
                    <div className="flex">
                        <CardMenuLocal name="Facturas" href="#factura" />
                        <div onClick={() => setMostrarTrurnos(!mostrarTrurnos)}>
                            <CardMenuLocal name="Turnos" href="#turno" />
                        </div>

                    </div>
                </div>
            </div>*/}

           <SeccionFactura />

            <hr className="mt-6 border-b-1 border-blueGray-300"/>

            {mostrarTrurnos && <SeccionTurnos />}

        </>
    );
};


